<template>
  <NormalHeaderLayout :header="getTabName()" :isWithoutCardWrapper="true">
    <div>
      <div class="input-wrapper">
        <div class="resource">
          <input-resource
            @fetchComparisonWidgets="handleFetchComparisonWidgets"
          ></input-resource>
        </div>
        <div
          class="tool"
          :class="{ disabled: comparisonResourceList.length === 0 }"
        >
          <input-tool
            @fetchComparisonWidgets="handleFetchComparisonWidgets"
          ></input-tool>
        </div>
      </div>
      <!-- Removed Submit button -->
      <!-- <button class="btn btn-primary" @click="getData" :disabled="isComparisonSubmitDisabled">{{$t('comparisonFeature.results.submitBtn')}}</button> -->
      <Spinner
        v-if="loading || (resultListExist && !widgetSpecReady)"
      ></Spinner>
      <div
        class="search-result"
        v-if="searchQuery && resultListExist && widgetSpecReady"
      >
        <ComparisonResult :tabId="tabId"></ComparisonResult>
      </div>
    </div>
  </NormalHeaderLayout>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import { isNavigationFailure, NavigationFailureType } from 'vue-router';
import i18n from '../i18n';
import ComparisonResult from '../components/search/ComparisonResult.vue';
import Spinner from '../components/ui/Spinner.vue';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout.vue';
import InputResource from '../components/comparison/InputResource.vue';
import InputTool from '../components/comparison/InputTool.vue';
import TOOLS from '../constants/tools';

export default {
  data() {
    return {
      tools: [],
      searchQuery: '',
      message: {},
      widgetSpecReady: false,
      tabId: '',
      experimentalMessage: {},
    };
  },
  computed: {
    ...mapState(['comparisonResourceList', 'selectedComparisonToolList']),
    ...mapGetters(['loading', 'resultListExist', 'isComparisonSubmitDisabled']),
    locale() {
      return i18n.locale;
    },
  },
  watch: {
    locale() {
      this.startSearch();
    },
    $route() {
      this.tabId = this.$route.name;
      this.startSearch();

      const routeParams = this.$route.params;

      if (!routeParams.pathMatch) {
        // when users click on Comparison tab in sidebar, the url will be "/apnic-comparison/" and routeParams.pathMatch will be ''
        // Allow users to submit in this scenario if Internet Number resources and tools have been selected
        this.setIsComparisonParamsChanged(true);
      }
    },
  },
  mounted() {
    this.tools = TOOLS.All;
    const { name, hash = '' } = this.$route;

    // set comparisonResourceList and selectedComparisonToolList by URL
    if (hash === '#tab=apnic-comparison') {
      this.setComparisonResourcesAndTools();
    } else {
      this.setIsComparisonParamsChanged(true);
    }

    this.tabId = name;
    this.startSearch();
    this.checkWidgetSpec();
  },
  methods: {
    ...mapMutations([
      'setIsComparisonParamsChanged',
      'updateSelectedComparisonToolList',
      'setComparisonResourceList',
    ]),

    checkWidgetSpec() {
      if (window.STAT_WIDGETS_SPEC) {
        this.widgetSpecReady = true;
      } else {
        setTimeout(() => this.checkWidgetSpec(), 500);
      }
    },

    getMessage() {
      try {
        let hashes = this.$route.hash.split('#');
        if (hashes && hashes.length > 1) {
          let params = hashes[1].split('&').map((i) => i.split('='));
          if (params) {
            params = Object.assign(
              {},
              ...params.map((x) => ({ [x[0]]: x[1] }))
            );
            if (params.category && params.index) {
              return {
                summary:
                  this.$tc('welcomePage.exampleTitle', 1) +
                  ' ' +
                  this.$route.params.pathMatch +
                  ' ' +
                  this.$tc('welcomePage.exampleTitle', 2),
                content: this.$t('welcomePage.' + params.category + '.items')[
                  params.index
                ].example.split('|'),
              };
            }
          }
        }
      } catch (e) {
        return {};
      }
      return {};
    },

    getTabName() {
      if (!this.tabId) return '';
      return this.$t('tabs')[this.tabId].name;
    },

    startSearch() {
      this.searchQuery = this.$route.params.pathMatch;
      this.$store.dispatch('searchResourceList', this.searchQuery);
    },

    getData() {
      this.setIsComparisonParamsChanged(false);
      let searchQuery = '';

      searchQuery =
        this.comparisonResourceList.join(',') +
        '_' +
        this.selectedComparisonToolList.map((i) => i.id).join(',');

      if (!searchQuery) {
        return;
      }

      // record events in GA of the selected tools
      this.selectedComparisonToolList.forEach((tool) => {
        window.dataLayer.push({
          event: 'compare',
          tool: tool.name,
        });
      });

      this.$router
        .push(`/search/${searchQuery}#tab=apnic-comparison`)
        .catch((err) => {
          const isRedirectFailure = isNavigationFailure(
            err,
            NavigationFailureType.redirected
          );

          if (!isRedirectFailure) {
            console.error('Error: ', err);
          }
        });
    },

    setComparisonResourcesAndTools() {
      const { params } = this.$route;

      if (!params?.pathMatch) return;

      const resourceListStr = params.pathMatch.split('_')[0];
      const toolListStr = params.pathMatch.split('_')[1];
      const resourceList = resourceListStr.split(',');
      this.setComparisonResourceList(resourceList);

      if (toolListStr) {
        const toolList = toolListStr.split(',');
        const comparisonToolList = toolList.map((tool) => {
          return this.tools.find((i) => i.id === tool);
        });
        this.updateSelectedComparisonToolList(comparisonToolList);
      }
    },

    handleFetchComparisonWidgets() {
      // Force fetch comparison widgets when current search query is the same as updated search query after adding an Internet resource. It will happen when remove an Internet resource or tool  and then add a same one (the route params is not changed in this circumstance).
      const currentSearchQuery = this.$route.params.pathMatch;
      const updatedSearchQuery =
        this.comparisonResourceList.join(',') +
        '_' +
        this.selectedComparisonToolList.map((i) => i.id).join(',');
      if (currentSearchQuery === updatedSearchQuery) {
        this.startSearch();
      }

      this.getData();
    },
  },
  components: {
    ComparisonResult,
    Spinner,
    NormalHeaderLayout,
    InputResource,
    InputTool,
  },
};
</script>

<style scoped lang="scss">
.sb1 div {
  margin: 0 auto;
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .resource {
    flex: 0 1 48%;
  }

  .tool {
    flex: 0 1 48%;
    margin-top: 0rem;
  }

  .disabled {
    opacity: 0.5;
  }
}

.btn {
  margin-top: 2rem;
  width: 24%;

  &:disabled {
    cursor: not-allowed;
  }
}

.search-result {
  margin-bottom: 4rem;
}

@include responsive(mobile) {
  .input-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .tool {
      margin-top: 1rem;
    }
  }

  .btn {
    margin-top: 1rem;
    width: 100%;
  }
}
</style>
